<template>
  <div class="my-outbox" @touchmove.prevent.self>
    <div class="my-outbox-inbox" ref="box" id="box">
      <div class="my-outbox-list" v-for="(item,index) in items" :key='index' :ref="'list'+index" :id="'list'+index">
        <img style="width:180px;height:200px;cursor:pointer;object-fit: scale-down;" @mouseover="stop" @mouseout="start"
          :src="item.path" :name="item.name" :label="item.name" @click="myclick(item.itemId,item.nid)" :title="item.name" /><br />
        <router-link :to="'/item/desc?itemId='+item.itemId +'&nid='+item.nid"><span @mouseover="stop" @mouseout="start"
            class="my-outbox-span1">{{item.name}}</span></router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import Vuex from 'vuex'

  import {
    getAllCarousel2
  } from '@/api/carousel.js'

  export default {
    name: 'my-marquee-left',
    data() {
      return {
        nowTime: null, //定时器标识
        disArr: [], //每一个内容的宽度
        items: [],
        startDis: 0,
      }
    },
    created() {
      clearInterval(this.nowTime);
    },
    beforeDestroy: function() {
      clearInterval(this.nowTime); //页面关闭清除定时器
      this.nowTime = null; //清除定时器标识
    },
    mounted() {
      getAllCarousel2("carousel/getAll", this);
    },
    methods: {
      stop: function() {
        clearInterval(this.nowTime);
      },
      start: function() {
        this.moveLeft();
      },
      isReady: function(that) {
        var len = that.$data.items.length;
        var arr = [];
        for (var i = 0; i < len; i++) {
          arr.push(200 + 25)
        }
        that.disArr = arr;
        that.moveLeft();
      },
      moveLeft: function() {
        var outbox = this.$refs.box;
        var that = this; //初始位置
        this.nowTime = setInterval(function() {
          that.$data.startDis -= 0.5;
          if (Math.abs(that.$data.startDis) > Math.abs(that.disArr[0])) {
            that.disArr.push(that.disArr.shift()) //每次移动完一个元素的距离，就把这个元素的宽度
            that.items.push(that.items.shift()) //每次移动完一个元素的距离，就把列表数据的第一项放到最后一项
            that.$data.startDis = 0;
          }
          outbox.style = 'transform: translateX(' + that.$data.startDis + 'px)'; //每次都让盒子移动指定的距离
        }, 1)
      },
      myclick: function(itemId, nid) {
        var path = "";
        if (itemId == 0) {
          path = "/"
        } else {
          path = "/item/desc?itemId=" + itemId + "&nid=" + nid
        }
        this.$router.push({
          path: path
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .my-outbox {
    width: 1200px;
    overflow: auto;
    height: 380px;
    background: white;
    margin: 0 auto;

    .my-outbox-inbox {
      white-space: nowrap;
      height: 100%;
      width: 100%;

      .my-outbox-list {
        margin-right: 12.5px;
        margin-left: 12.5px;
        width: 200px;
        display: inline-block;
        font-size: 15px;
        height: 35px;
        line-height: 35px;
        position: relative;
        top: 60px;

        .my-uname {
          color: #FF8900;
        }
      }
    }
  }

  .my-outbox-span1 {
    width: 200px;
    display: block;
    word-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Outbox.vue